module.exports = __webpack_public_path__ + "list_view.6ec51ece.png";